import { format, isAfter, isBefore, startOfDay } from 'date-fns';

export const parseApiDate = (dateStr: string | null | undefined): Date => {
  if (!dateStr) return new Date();
  
  // Extract just the date part YYYY-MM-DD to avoid timezone shifting
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10) - 1;
    const day = parseInt(match[3], 10);
    return new Date(year, month, day);
  }
  
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? new Date() : date;
};

export const formatDate = (date: Date | string, formatStr: string = 'MMM dd, yyyy'): string => {
  const dateObj = typeof date === 'string' ? parseApiDate(date) : date;
  return format(dateObj, formatStr);
};

export const isOverdue = (dueDate: Date | string): boolean => {
  const due = typeof dueDate === 'string' ? parseApiDate(dueDate) : dueDate;
  return isBefore(due, startOfDay(new Date()));
};

export const isDueToday = (dueDate: Date | string): boolean => {
  const due = typeof dueDate === 'string' ? parseApiDate(dueDate) : dueDate;
  const today = startOfDay(new Date());
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  
  return !isBefore(due, today) && isBefore(due, tomorrow);
};

export const isDueThisWeek = (dueDate: Date | string): boolean => {
  const due = typeof dueDate === 'string' ? parseApiDate(dueDate) : dueDate;
  const today = startOfDay(new Date());
  const weekEnd = new Date(today);
  weekEnd.setDate(weekEnd.getDate() + 7);
  
  return !isBefore(due, today) && isBefore(due, weekEnd);
};

